export default "__VITE_ASSET__CKHMA6Xh__"